<div
  class="header_container"
  id="header_container"
  [ngStyle]="{ display: !showHeader ? 'none' : 'flex' }"
>
  <div class="mobile_header">
    <a
      [routerLink]="logoRouterLink"
      (click)="switchPage()"
      class="pinploy_logo_header"
    >
      <img class="logo_in_header" src="{{ logo }}" alt="logo" />
    </a>

    <mat-icon
      class="notranslate menu_icon first"
      (click)="openSidebarNotifications()"
      [matBadgeHidden]="newNotificationsCount === 0"
      [matBadge]="newNotificationsCount"
      matBadgeColor="warn"
      >notifications
    </mat-icon>
  </div>

  <div class="desktop_header">
    <div class="desktop_header_left">
      <a
        [routerLink]="logoRouterLink"
        class="pinploy_logo_header"
        (click)="switchPage()"
      >
        <img class="logo_in_header" src="{{ logo }}" alt="logo" />
      </a>

      <button class="call_to_action_create_task" routerLink="/opret">
        {{
          'COMPONENTS.HEADER.CREATE'
            | translate: currentTranslationLanguageTrigger
        }}
      </button>

      <div class="menu_item" style="margin-left: 20px">
        <p
          class="nav_item_text"
          [ngClass]="{ selected: activeTab === 0 }"
          (click)="changeTab(0)"
        >
          {{
            'COMPONENTS.HEADER.HOME'
              | translate: currentTranslationLanguageTrigger
          }}
        </p>
        <div class="underscore" *ngIf="activeTab === 0"></div>
      </div>

      <div class="menu_item">
        <p
          class="nav_item_text"
          [ngClass]="{ selected: activeTab === 1 }"
          (click)="changeTab(1)"
        >
          {{
            'COMPONENTS.HEADER.DASHBOARD'
              | translate: currentTranslationLanguageTrigger
          }}
        </p>
        @if (activeTab === 1) {
          <div class="underscore"></div>
        }
      </div>
    </div>

    <div class="desktop_header_right">
      <div class="menu_item">
        <p
          class="nav_item_text"
          [ngClass]="{ selected: activeTab === 5 }"
          (click)="changeTab(5)"
        >
          {{
            'COMPONENTS.HEADER.HELP'
              | translate: currentTranslationLanguageTrigger
          }}
        </p>
        <div class="underscore" *ngIf="activeTab === 5"></div>
      </div>

      <div class="menu_item">
        <p
          class="nav_item_text"
          matBadgeColor="warn"
          [matBadgeHidden]="hideBadge('forum')"
          [matBadge]="newMessagesCount"
          [ngClass]="{ selected: activeTab === 2 }"
          (click)="changeTab(2)"
        >
          {{
            'COMPONENTS.HEADER.MESSAGES'
              | translate: currentTranslationLanguageTrigger
          }}
        </p>
        @if (activeTab === 2) {
          <div class="underscore"></div>
        }
      </div>

      <div class="menu_item" (click)="openSidebarNotifications()">
        <p
          class="nav_item_text"
          matBadgeColor="warn"
          [matBadgeHidden]="hideBadge('notifications')"
          [matBadge]="newNotificationsCount"
          [ngClass]="{ selected: activeTab === 3 }"
          (click)="changeTab(3)"
        >
          {{
            'COMPONENTS.HEADER.NOTIFICATIONS'
              | translate: currentTranslationLanguageTrigger
          }}
        </p>
        @if (activeTab === 3) {
          <div class="underscore"></div>
        }
      </div>

      <div class="menu_item" (click)="openSidebar()" id="open-sidebar">
        <div class="myProfile">
          <p class="nav_item_text" [ngClass]="{ selected: activeTab === 4 }">
            {{ storage?.user?.firstName }}
          </p>
          @if (storage?.user?.profileImg !== null) {
            <img
              class="profile_image"
              src="{{ storage?.user.profileImg }}"
              (error)="onImgError($event)"
              [ngClass]="{ selected: activeTab === 4 }"
              alt="profile image"
            />
          } @else {
            <mat-icon
              [ngClass]="{ selected: activeTab === 4 }"
              class="notranslate_profile_icon"
              >account_circle
            </mat-icon>
          }
        </div>
        <div class="underscore last_underscore" *ngIf="activeTab === 4"></div>
      </div>
    </div>
  </div>
</div>
<app-sidebar></app-sidebar>
